import MultiFloatingFilterDatetime from '../../../../component/Common/Datagrid/Component/MultiFilterRenderer/MultiFloatingFilterDatetime';
import MultiFilterHiddenInput from '../../../../component/Common/Datagrid/Component/MultiFilterRenderer/MultiFilterHiddenInput';
import generateDatetimeTreePath from './generateDatetimeTreePath';

const generateDatetimeFilters = () => {
  return {
    suppressFloatingFilterButton: false,
    filter: 'agMultiColumnFilter',
    filterParams: {
      filters: [
        {
          filter: MultiFilterHiddenInput,
          floatingFilterComponent: MultiFloatingFilterDatetime,
        },
        {
          filter: 'agSetColumnFilter',
          filterParams: {
            treeList: true,
            excelMode: 'windows',
            closeOnApply: true,
            cellHeight: 24,
            treeListPathGetter: generateDatetimeTreePath,
          },
        },
      ],
    },
  };
};

export default generateDatetimeFilters;
